  var SHOPIFY_BASE_URL = 'https://cdn.shopify.com/s/files/1/1409/2656/';
  var colors = {'0101':'pebbled-black','0102':'pebbled-brown','0103':'pebbled-red','0104':'pebbled-purple','0105':'pebbled-cobalt-blue','0106':'pebbled-sky-blue','0107':'pebbled-magenta','0108':'pebbled-metallic-silver','0109':'pebbled-white','0110':'pebbled-orange','0111':'pebbled-tan','0201':'smooth-black','0212':'smooth-coffee-brown','0213':'smooth-chocolate-brown','0214':'smooth-cognac','0215':'smooth-navy','0216':'smooth-gray','0301':'glossy-black','0401':'suede-black','0417':'suede-dark-brown','0501':'snakeskin-black'};
  function addColorSwatches(element) {
    var colorSet = {};
    $(element).find('.variant').each(function(i, variant) {
      var sku = $(variant).attr('class');
      var colorSku = sku.substring(15,19);
      var color = colors[colorSku];
      colorSet[color] = $(variant).html();
    });
    var swatchHtml = '';
    var url = window.location + '';
    var selectedVariant = false;
    for (var k in colorSet) {
      if (url.indexOf(k) > 0 || !selectedVariant) {
        selectedVariant = k;
      }
    }
    for (var k in colorSet) {
      var title = k.split('-').map(function(s) { return s[0].toUpperCase() + s.substring(1); } ).join(' ');
      
      var img = SHOPIFY_BASE_URL + colorSet[k];
      img = img.replace('.jpg', '_large.jpg');
      var selected = '';
      if (k == selectedVariant) {
        $(element).find('img.main-image').attr('src', img);
        $(element).find('img.main-image').attr('data-src', img);
        selected = ' color-swatch-selected';
      }
      
      var html = '<a href="javascript:void(0)"><div class="color-swatch-sm color-swatch-'+k+selected+'" title="'+title+'" data-toggle="tooltip" data-placement="top" data-container="body" onclick="setVariant(this, \''+img+'\')" ontouchstart="setVariant(this, \''+img+'\')"></div></a>';
      swatchHtml += html;
    }
    if (Object.keys(colorSet).length > 1) {
	  $(element).find('.bello-swatches').html(swatchHtml);
    }
  }
  
  function setVariant(element, img) {
    $(element).parent().parent().find('div').removeClass('color-swatch-selected');
    $(element).addClass('color-swatch-selected');
    $(element).parents('.product-head').find('img.main-image').attr('src', img);
  }

  function toggleTag(tagName, allTagsString) {
    var t = toTag(tagName);
    var tags = allTagsString.split('|').map(toTag);
    var url = window.location + "";
    var query = '';
    if (url.indexOf('?') > 0) {
      var i = url.indexOf('?');
      query = url.substring(i);
      url = url.substring(0,i);
    }
    var parts = url.split('/');
    var newTags = [];
    var basePath = parts[0] + '/' + parts[1] + '/' + parts[2] + '/' + parts[3] + '/' + parts[4];
    if (parts.length == 5) {
      newTags = [t];
    } else {
      var currentTags = parts[5].split('+');
      if (currentTags.indexOf(t) > -1) {
        // remove t from tag list
        newTags = currentTags.filter(function(ct) { return ct != t; } );
      } else {
        // remove any tags that are in the tagStr group, then add t
        newTags = currentTags.filter(function(ct) { return tags.indexOf(ct) == -1 });
        newTags.push(t);
      }
    }
    if (newTags.length > 0) {
      window.location = basePath + '/' + newTags.join('+') + query;
    } else {
      window.location = basePath + query;
    }
  }
  
  function toggleGenderTag(tagName, allTagsString) {
    if (tagName == 'men') {
      allTagsString = 'Men|Women|Width 0.5|Width 0.75|Width 1.0|Width 1.25|Width 1.5|Width 2+|Casual|Dressy|Classic|Contemporary|Statement|Great For Dresses|Great For Jeans|Wrap Belts|Benefit Buckle|Animal Buckle';
    }
    toggleTag(tagName, allTagsString);
  }
  
  function toTag(string) {
    var tag = string.toLowerCase();
    tag = tag.replace(/[ .]+/g, '-')
    tag = tag.replace(/[^a-z0-9-]+/g, '')
    return tag;
  }
